import { gql } from "@apollo/client"

export const GET_PARTICIPANT = gql`
  query AuthenticatedParticipant($participant_id: ID!) {
    participant: authenticatedParticipant(participant_id: $participant_id) {
      participant_id
      participant_membership_id
      participant_membership_status
      participant_name_first
      participant_name_last
      participant_email_account
      participant_create_date
      participant_alias
      staff_role
      staff_role_name
      enterprise_id
      enterprise_alias
      organization_id
      organization_alias
      organization_name
      participant_profile_image
      staff_assigment_list {
        staff_id
        staff_name_first
        staff_name_last
        staff_email_address
        staff_alias
      }
      __typename
    }
  }
`

export const GET_MICROSERVICES_BY_ORGANIZATION = gql`
  query GetMicroservicesByOrganization(
    $staff_id: ID!
    $staff_organization_id: ID!
    $organization_id: ID!
  ) {
    getMicroservicesByOrganization(
      staff_id: $staff_id
      staff_organization_id: $staff_organization_id
      organization_id: $organization_id
    ) {
      microservices_id
      microservices_name
      microservices_enabled
    }
  }
`
